(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funcinating-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-funcinating-header]').forEach((header) => {
    if (header.dataset.funcinatingHeaderReady === 'true') return;
    header.dataset.funcinatingHeaderReady = 'true';

    const cartUrl = header.getAttribute('data-cart-url') || '/cart';
    const cartClearUrl = header.getAttribute('data-cart-clear-url') || '/cart/clear';
    const currentRouteRoot = header.getAttribute('data-current-route-root') || window.Shopify?.routes?.root || '/';
    const currentLanguageRoot = header.getAttribute('data-current-language-root') || '/';
    const currentCountry = (header.getAttribute('data-current-country') || '').toUpperCase();
    const ipinfoLiteToken = header.getAttribute('data-ipinfo-lite-token') || '';
    const regionRecommendationDismissDays = Math.max(
      1,
      Number(header.getAttribute('data-region-recommendation-dismiss-days') || 30)
    );
    const regionRecommendationStorageKey = 'funcinating_region_recommendation_v1';
    let regionChangeInProgress = false;
    const clearError = 'We could not clear the cart. Please try again before switching country/region.';
    const countryPicker = header.querySelector('[data-funcinating-country-picker]');

    function showRegionCartClearDialog(options = {}) {
      const dialog = header.querySelector('[data-region-confirm-modal]');
      if (!dialog || typeof dialog.showModal !== 'function') return Promise.resolve(false);

      const isError = options.variant === 'error';
      const title = dialog.querySelector('[data-region-confirm-title]');
      const message = dialog.querySelector('[data-region-confirm-message]');
      const error = dialog.querySelector('[data-region-confirm-error]');
      const cancel = dialog.querySelector('[data-region-confirm-cancel]');
      const accept = dialog.querySelector('[data-region-confirm-accept]');

      if (!cancel || !accept) return Promise.resolve(false);
      if (title) {
        title.textContent = isError
          ? dialog.dataset.errorTitle || ''
          : options.title || dialog.dataset.confirmTitle || '';
      }
      if (message) {
        message.textContent = isError
          ? options.error || dialog.dataset.errorMessage || ''
          : options.message || dialog.dataset.confirmMessage || '';
      }
      if (error) {
        error.textContent = options.error || '';
        error.hidden = !options.error || isError;
      }

      cancel.textContent = isError
        ? dialog.dataset.dismissLabel || dialog.dataset.cancelLabel || 'OK'
        : options.cancelLabel || dialog.dataset.cancelLabel || 'Cancel';
      accept.textContent = options.acceptLabel || dialog.dataset.acceptLabel || 'Continue';
      accept.hidden = isError;

      if (dialog.open) dialog.close();

      return new Promise((resolve) => {
        let settled = false;

        function cleanup() {
          accept.removeEventListener('click', onAccept);
          cancel.removeEventListener('click', onCancelClick);
          dialog.removeEventListener('cancel', onCancel);
          dialog.removeEventListener('close', onClose);
        }

        function settle(value) {
          if (settled) return;
          settled = true;
          cleanup();
          if (dialog.open) dialog.close();
          resolve(value);
        }

        function onAccept() {
          settle(true);
        }

        function onCancelClick() {
          settle(false);
        }

        function onCancel(event) {
          event.preventDefault();
          settle(false);
        }

        function onClose() {
          settle(false);
        }

        accept.addEventListener('click', onAccept);
        cancel.addEventListener('click', onCancelClick);
        dialog.addEventListener('cancel', onCancel);
        dialog.addEventListener('close', onClose);
        dialog.showModal();
        setTimeout(() => (isError ? cancel : accept).focus(), 0);
      });
    }

    window.FuncinatingRegion = window.FuncinatingRegion || {};
    window.FuncinatingRegion.showRegionCartClearDialog = showRegionCartClearDialog;

    function jsonUrl(path) {
      const url = new URL(path, window.location.origin);
      if (!url.pathname.endsWith('.js')) {
        url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
      }
      return url.toString();
    }

    function normalizeRoot(root) {
      if (!root || root === '/') return '/';
      return root.endsWith('/') ? root.slice(0, -1) : root;
    }

    function stripCurrentRoot(path) {
      const currentRoots = [currentLanguageRoot, currentRouteRoot]
        .map(normalizeRoot)
        .filter((root, index, roots) => root !== '/' && roots.indexOf(root) === index)
        .sort((left, right) => right.length - left.length);

      for (const root of currentRoots) {
        if (path === root || path.startsWith(`${root}/`)) {
          return path.slice(root.length) || '/';
        }
      }

      return path;
    }

    function buildLanguageUrl(nextRoot) {
      const targetRoot = normalizeRoot(nextRoot);
      let nextPath = stripCurrentRoot(window.location.pathname || '/');

      if (targetRoot !== '/') {
        nextPath = nextPath === '/' ? targetRoot : `${targetRoot}${nextPath}`;
      }

      return `${nextPath}${window.location.search}${window.location.hash}`;
    }

    async function hasCartItems() {
      try {
        const response = await fetch(jsonUrl(cartUrl), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return true;
        const cart = await response.json();
        return Number(cart?.item_count || 0) > 0;
      } catch {
        return true;
      }
    }

    async function clearCart() {
      try {
        const response = await fetch(jsonUrl(cartClearUrl), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        return response.ok;
      } catch {
        return false;
      }
    }

    function readRegionRecommendationChoice() {
      try {
        const raw = window.localStorage.getItem(regionRecommendationStorageKey);
        if (!raw) return null;
        const choice = JSON.parse(raw);
        if (!choice || Number(choice.expiresAt || 0) < Date.now()) {
          window.localStorage.removeItem(regionRecommendationStorageKey);
          return null;
        }
        return choice;
      } catch {
        return null;
      }
    }

    function rememberRegionRecommendation(action, countryCode) {
      try {
        const ttl = regionRecommendationDismissDays * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(
          regionRecommendationStorageKey,
          JSON.stringify({
            action,
            countryCode,
            expiresAt: Date.now() + ttl,
          })
        );
      } catch {
        // localStorage can be unavailable in private browsing; the feature should fail quietly.
      }
    }

    function getPrimaryCountrySelect() {
      return header.querySelector('[data-funcinating-country-select]');
    }

    function formatRecommendationTemplate(template, countryLabel) {
      return (template || '').replace(/%country%/g, countryLabel);
    }

    async function getIpinfoCountryCode() {
      const url = `https://api.ipinfo.io/lite/me?token=${encodeURIComponent(ipinfoLiteToken)}`;
      const response = await fetch(url);
      if (!response.ok) return '';
      const data = await response.json();
      return (data?.country_code || '').toUpperCase();
    }

    async function onAcceptRecommendedRegion(countryOption) {
      const select = getPrimaryCountrySelect();
      const form = select?.form;
      if (!select || !form || !countryOption?.code || regionChangeInProgress) return;

      regionChangeInProgress = true;
      select.value = countryOption.code;
      select.setAttribute('aria-busy', 'true');

      if (await hasCartItems()) {
        const shouldClear = await showRegionCartClearDialog();
        if (!shouldClear) {
          select.value = currentCountry;
          select.removeAttribute('aria-busy');
          regionChangeInProgress = false;
          rememberRegionRecommendation('dismissed', countryOption.code);
          return;
        }

        if (!(await clearCart())) {
          await showRegionCartClearDialog({ variant: 'error', error: clearError });
          select.value = currentCountry;
          select.removeAttribute('aria-busy');
          regionChangeInProgress = false;
          return;
        }
      }

      rememberRegionRecommendation('switched', countryOption.code);
      form.submit();
    }

    async function initRegionRecommendation() {
      if (!ipinfoLiteToken || !currentCountry) return;
      if (window.Shopify?.designMode) return;
      if (readRegionRecommendationChoice()) return;
      if (window.FuncinatingRegionRecommendationStarted) return;

      window.FuncinatingRegionRecommendationStarted = true;

      try {
        const visitorCountry = await getIpinfoCountryCode();
        if (!visitorCountry || visitorCountry === currentCountry) return;

        const countryOption = getCountryOption(visitorCountry);
        if (!countryOption) return;

        const countryLabel = countryOption.label;
        const accepted = await showRegionCartClearDialog({
          eyebrow: header.getAttribute('data-region-recommend-eyebrow') || '',
          title: formatRecommendationTemplate(
            header.getAttribute('data-region-recommend-title-template') || '',
            countryLabel
          ),
          message: formatRecommendationTemplate(
            header.getAttribute('data-region-recommend-message-template') || '',
            countryLabel
          ),
          currentCountryLabel: getCountryOption(currentCountry)?.label || '',
          targetCountryLabel: countryLabel,
          cancelLabel: header.getAttribute('data-region-recommend-cancel-label') || '',
          acceptLabel: header.getAttribute('data-region-recommend-accept-label') || '',
        });

        if (!accepted) {
          rememberRegionRecommendation('dismissed', visitorCountry);
          return;
        }

        await onAcceptRecommendedRegion(countryOption);
      } catch {
        // IP lookup is only a recommendation. Network or API failures should never block shopping.
      }
    }

    let activeCountryInput = null;

    function getCountryPickerButtons() {
      return Array.from(header.querySelectorAll('[data-funcinating-country-picker-option]'));
    }

    function getCountryOption(countryCode) {
      const normalizedCode = (countryCode || '').toUpperCase();
      if (!normalizedCode) return null;
      const button = getCountryPickerButtons().find(
        (item) => (item.getAttribute('data-country-code') || '').toUpperCase() === normalizedCode
      );
      if (!button) return null;
      const label = button.getAttribute('data-country-label') || '';
      const currency = button.getAttribute('data-country-currency') || '';
      return {
        code: normalizedCode,
        label: currency ? `${label} / ${currency}` : label,
      };
    }

    function syncCountryPickerSelection(countryCode) {
      const normalizedCode = (countryCode || '').toUpperCase();
      getCountryPickerButtons().forEach((button) => {
        const buttonCode = (button.getAttribute('data-country-code') || '').toUpperCase();
        button.classList.toggle('is-active', buttonCode === normalizedCode);
      });
    }

    function setCountryTriggerExpanded(expanded) {
      header.querySelectorAll('[data-funcinating-country-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function closeCountryPicker() {
      if (!(countryPicker instanceof HTMLDialogElement) || !countryPicker.open) return;
      countryPicker.close();
    }

    function openCountryPicker(countryInput) {
      if (!(countryPicker instanceof HTMLDialogElement) || !(countryInput instanceof HTMLInputElement)) return;
      activeCountryInput = countryInput;
      syncCountryPickerSelection(countryInput.value);
      setCountryTriggerExpanded(true);
      if (!countryPicker.open) countryPicker.showModal();
    }

    header.querySelectorAll('[data-funcinating-country-trigger]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.closest('form')?.querySelector('[data-funcinating-country-select]');
        if (!(input instanceof HTMLInputElement)) return;
        if (countryPicker?.open && activeCountryInput === input) {
          closeCountryPicker();
          return;
        }
        openCountryPicker(input);
      });
    });

    countryPicker?.addEventListener('click', (event) => {
      if (event.target === countryPicker) closeCountryPicker();
    });

    countryPicker?.addEventListener('close', () => {
      setCountryTriggerExpanded(false);
      activeCountryInput = null;
    });

    countryPicker?.querySelector('[data-funcinating-country-picker-close]')?.addEventListener('click', () => {
      closeCountryPicker();
    });

    countryPicker?.querySelectorAll('[data-funcinating-country-picker-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const countryCode = button.getAttribute('data-country-code') || '';
        if (!(activeCountryInput instanceof HTMLInputElement) || !countryCode) return;

        activeCountryInput.value = countryCode;
        activeCountryInput.dispatchEvent(new Event('change', { bubbles: true }));
        closeCountryPicker();
      });
    });

    header.querySelectorAll('[data-funcinating-country-select]').forEach((select) => {
      select.addEventListener('change', async () => {
        const previousCountry = select.getAttribute('data-current-country') || '';
        const nextCountry = select.value;
        const form = select.form;

        if (!form || !nextCountry) return;

        if (regionChangeInProgress) {
          select.value = previousCountry;
          return;
        }

        if (nextCountry === previousCountry) {
          form.submit();
          return;
        }

        regionChangeInProgress = true;
        select.setAttribute('aria-busy', 'true');

        if (await hasCartItems()) {
          const shouldClear = await showRegionCartClearDialog({
            currentCountryLabel: getCountryOption(previousCountry)?.label || '',
            targetCountryLabel: getCountryOption(nextCountry)?.label || '',
          });
          if (!shouldClear) {
            select.value = previousCountry;
            select.removeAttribute('aria-busy');
            regionChangeInProgress = false;
            return;
          }

          if (!(await clearCart())) {
            await showRegionCartClearDialog({ variant: 'error', error: clearError });
            select.value = previousCountry;
            select.removeAttribute('aria-busy');
            regionChangeInProgress = false;
            return;
          }
        }

        rememberRegionRecommendation('manual', nextCountry);
        form.submit();
      });
    });

    header.querySelectorAll('[data-funcinating-language-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const languageCode = button.getAttribute('data-language-code');
        const languageUrl = button.getAttribute('data-language-url');
        const form = button.closest('form');
        const input = form?.querySelector('[data-funcinating-language-input]');
        if (!form || !input || !languageCode || input.value === languageCode) return;

        input.value = languageCode;
        if (languageUrl) {
          window.location.assign(buildLanguageUrl(languageUrl));
          return;
        }
        form.submit();
      });
    });

    const desktopCollectionsQuery = window.matchMedia('(min-width: 750px)');
    const desktopCollectionsDropdowns = Array.from(
      header.querySelectorAll('.funcinating-header__nav-dropdown')
    );

    function closeDesktopCollectionsDropdowns(exceptDropdown) {
      desktopCollectionsDropdowns.forEach((dropdown) => {
        if (dropdown !== exceptDropdown) dropdown.open = false;
      });
    }

    desktopCollectionsDropdowns.forEach((dropdown) => {
      const summary = dropdown.querySelector('summary');
      if (!summary) return;

      let closeTimer;

      dropdown.addEventListener('mouseenter', () => {
        if (!desktopCollectionsQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeDesktopCollectionsDropdowns(dropdown);
        dropdown.open = true;
      });

      dropdown.addEventListener('mouseleave', () => {
        if (!desktopCollectionsQuery.matches) return;
        closeTimer = window.setTimeout(() => {
          dropdown.open = false;
        }, 120);
      });

      dropdown.addEventListener('focusout', () => {
        if (!desktopCollectionsQuery.matches) return;
        window.setTimeout(() => {
          if (!dropdown.contains(document.activeElement)) dropdown.open = false;
        }, 0);
      });

      summary.addEventListener('click', (event) => {
        if (!desktopCollectionsQuery.matches) return;
        event.preventDefault();
        const shouldOpen = !dropdown.open;
        closeDesktopCollectionsDropdowns(dropdown);
        dropdown.open = shouldOpen;
      });
    });

    desktopCollectionsQuery.addEventListener('change', (event) => {
      if (event.matches) return;
      closeDesktopCollectionsDropdowns();
    });

    initRegionRecommendation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funcinating-main-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-article-toc]').forEach(function (toc) {
    var article = toc.closest('.funcinating-article');
    if (!article) return;
    var body = article.querySelector('.funcinating-article__body');
    if (!body) return;
    var heads = body.querySelectorAll('h2');
    if (heads.length < 3) return;
    var list = toc.querySelector('[data-toc-list]');
    var used = {};
    heads.forEach(function (h) {
      var text = h.textContent.trim();
      if (!text) return;
      var slug = text.toLowerCase().replace(/[^\w\u4e00-\u9fa5]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
      if (used[slug]) { used[slug]++; slug = slug + '-' + used[slug]; } else { used[slug] = 1; }
      h.id = slug;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + slug;
      a.textContent = text;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + slug);
      });
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
  });

  document.querySelectorAll('[data-news-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-news-gallery-track]');
    var realSlides = Array.from(gallery.querySelectorAll('[data-news-gallery-slide]:not([data-news-gallery-clone])'));
    var dots = Array.from(gallery.querySelectorAll('[data-news-gallery-dot]'));
    var activeIndex = 0;
    var scrollFrame;
    var settleTimer;
    var smoothBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    if (!track || realSlides.length <= 1) return;

    var setActive = function (index) {
      activeIndex = Math.max(0, Math.min(index, realSlides.length - 1));
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    };

    var jumpToRealSlide = function (index) {
      setActive(index);
      track.scrollTo({ left: track.clientWidth * (activeIndex + 1), behavior: 'auto' });
    };

    var slideTo = function (index, behavior) {
      var nextIndex = (index + realSlides.length) % realSlides.length;
      var physicalIndex = nextIndex + 1;

      if (activeIndex === realSlides.length - 1 && index > activeIndex) {
        physicalIndex = realSlides.length + 1;
      }
      if (activeIndex === 0 && index < activeIndex) {
        physicalIndex = 0;
      }

      track.scrollTo({ left: track.clientWidth * physicalIndex, behavior: behavior || smoothBehavior });
      setActive(nextIndex);
    };

    var settle = function () {
      var physicalIndex = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (physicalIndex === 0) {
        jumpToRealSlide(realSlides.length - 1);
        return;
      }
      if (physicalIndex === realSlides.length + 1) {
        jumpToRealSlide(0);
        return;
      }
      setActive(physicalIndex - 1);
    };

    track.addEventListener('scroll', function () {
      cancelAnimationFrame(scrollFrame);
      clearTimeout(settleTimer);
      scrollFrame = requestAnimationFrame(function () {
        var physicalIndex = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (physicalIndex === 0) {
          setActive(realSlides.length - 1);
        } else if (physicalIndex === realSlides.length + 1) {
          setActive(0);
        } else {
          setActive(physicalIndex - 1);
        }
      });
      settleTimer = setTimeout(settle, 120);
    }, { passive: true });

    track.addEventListener('scrollend', settle);

    gallery.querySelector('[data-news-gallery-prev]')?.addEventListener('click', function () {
      slideTo(activeIndex - 1);
    });
    gallery.querySelector('[data-news-gallery-next]')?.addEventListener('click', function () {
      slideTo(activeIndex + 1);
    });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        slideTo(index);
      });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        jumpToRealSlide(activeIndex);
      }).observe(track);
    }

    requestAnimationFrame(function () {
      jumpToRealSlide(0);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funcinating-main-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-funcinating-collection]').forEach((section) => {
    if (section.dataset.funcinatingCollectionReady === 'true') return;
    section.dataset.funcinatingCollectionReady = 'true';

    const filters = section.querySelector('[data-funcinating-filters]');
    const grid = section.querySelector('[data-funcinating-grid]');
    const emptyState = section.querySelector('[data-funcinating-filter-empty]');
    const pagination = section.querySelector('[data-funcinating-pagination]');
    const loadError = section.querySelector('[data-funcinating-load-error]');
    const collectionHandle = section.getAttribute('data-collection-handle') || '';
    const supportedBadgeFilterOrder = ['hot', 'new'];
    const supportedIpFilterOrder = ['gismow', 'koucomi', 'tarti', 'calor', 'chuangasia'];
    let activeFilter = 'all';
    let isLoadingMore = false;

    function getCards() {
      return Array.from(section.querySelectorAll('.funcinating-product-card'));
    }

    function createFilterButton(key, label) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'funcinating-collection__filter';
      button.setAttribute('data-funcinating-filter', key);
      button.setAttribute('aria-pressed', 'false');
      button.textContent = label;
      button.addEventListener('click', () => applyFilter(key, 'smooth'));
      return button;
    }

    function scrollActiveFilterIntoView(activeButton, behavior = 'auto') {
      if (!filters || !activeButton) return;

      const maxScrollLeft = filters.scrollWidth - filters.clientWidth;
      if (maxScrollLeft <= 0) return;

      const buttonCenter = activeButton.offsetLeft + activeButton.offsetWidth / 2;
      const idealScrollLeft = buttonCenter - filters.clientWidth / 2;
      const nextScrollLeft = Math.max(0, Math.min(maxScrollLeft, idealScrollLeft));

      filters.scrollTo({
        left: nextScrollLeft,
        behavior
      });
    }

    function getFilterOptions() {
      const options = new Map();

      getCards().forEach((card) => {
        const labels = card.getAttribute('data-filter-labels') || '';
        labels.split('|').forEach((entry) => {
          if (!entry) return;
          const [key, label] = entry.split('::');
          if (!key || key === 'frontpage') return;
          options.set(key, label || key.toUpperCase());
        });
      });

      const supportedBadgeOptions = Array.from(options.entries())
        .map(([key, label]) => ({ key, label }))
        .filter((option) => supportedBadgeFilterOrder.includes(option.key));
      const orderedBadgeOptions = supportedBadgeFilterOrder
        .map((key) => supportedBadgeOptions.find((option) => option.key === key))
        .filter(Boolean);

      if (collectionHandle !== 'all') {
        return orderedBadgeOptions;
      }

      const supportedIpOptions = Array.from(options.entries())
        .map(([key, label]) => ({ key, label }))
        .filter((option) => supportedIpFilterOrder.includes(option.key));
      const orderedIpOptions = supportedIpFilterOrder
        .map((key) => supportedIpOptions.find((option) => option.key === key))
        .filter(Boolean);

      return [...orderedBadgeOptions, ...orderedIpOptions];
    }

    function renderFilters() {
      if (!filters) return;

      const options = getFilterOptions();
      filters.innerHTML = '';

      if (collectionHandle !== 'all') {
        filters.hidden = true;
        return;
      }

      filters.hidden = false;
      options.forEach((option) => {
        filters.appendChild(createFilterButton(option.key, option.label));
      });
      filters.appendChild(createFilterButton('all', filters.getAttribute('data-all-label') || 'All'));
    }

    function applyFilter(filterKey, scrollBehavior = 'auto') {
      activeFilter = filterKey;
      let visibleCount = 0;
      const buttons = Array.from(section.querySelectorAll('[data-funcinating-filter]'));
      let activeButton = null;

      buttons.forEach((button) => {
        const isActive = button.getAttribute('data-funcinating-filter') === filterKey;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
        if (isActive) activeButton = button;
      });

      getCards().forEach((card) => {
        const keys = card.getAttribute('data-filter-keys') || '|';
        const isVisible = filterKey === 'all' || keys.includes(`|${filterKey}|`);
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (emptyState) emptyState.hidden = visibleCount > 0;
      scrollActiveFilterIntoView(activeButton, scrollBehavior);
    }

    function normalizePagination() {
      if (!pagination) return;
      const nextLink = pagination.querySelector('.next a');
      pagination.hidden = !nextLink;
    }

    async function loadMore(nextLink) {
      if (!grid || isLoadingMore) return;

      isLoadingMore = true;
      if (loadError) loadError.hidden = true;

      const originalText = nextLink.textContent;
      const loadingLabel = pagination?.querySelector('[data-loading-label]')?.getAttribute('data-loading-label') || 'Loading...';
      nextLink.textContent = loadingLabel;
      nextLink.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(nextLink.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load more products');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = doc.querySelector('[data-funcinating-collection]');
        const nextGrid = nextSection?.querySelector('[data-funcinating-grid]');
        const nextCards = nextGrid ? Array.from(nextGrid.querySelectorAll('.funcinating-product-card')) : [];
        const nextPagination = nextSection?.querySelector('[data-funcinating-pagination]');

        if (!nextSection || !nextGrid || !nextCards.length) {
          throw new Error('Unable to load more products');
        }

        nextCards.forEach((card) => grid.appendChild(card));

        if (pagination) {
          pagination.innerHTML = nextPagination ? nextPagination.innerHTML : '';
        }

        renderFilters();
        applyFilter(activeFilter, 'auto');
        normalizePagination();
      } catch (error) {
        if (loadError) loadError.hidden = false;
        nextLink.textContent = originalText;
        nextLink.removeAttribute('aria-busy');
      } finally {
        isLoadingMore = false;
      }
    }

    if (pagination) {
      pagination.addEventListener('click', (event) => {
        const nextLink = event.target.closest('.next a');
        if (!nextLink) return;
        event.preventDefault();
        loadMore(nextLink);
      });
    }

    renderFilters();
    applyFilter(activeFilter, 'auto');
    normalizePagination();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funcinating-main-product"]) return;
  try {
    
  const initFuncinatingProduct = (root) => {
    const variantsScript = root.querySelector('[data-variants-json]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
    const form = root.querySelector('[data-product-form]');
    const variantInput = root.querySelector('[data-variant-input]');
    const sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    const preorderNotice = root.querySelector('[data-preorder-notice]');
    const price = root.querySelector('[data-product-price]');
    const comparePrice = root.querySelector('[data-product-compare-price]');
    const productBadge = root.querySelector('[data-product-badge]');
    const addToCart = root.querySelector('[data-add-to-cart]');
    const buyNow = root.querySelector('[data-buy-now]');
    const originalButtons = root.querySelector('.funcinating-product__buttons');
    const stickyPurchase = root.querySelector('[data-sticky-purchase]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyOption = root.querySelector('[data-sticky-option]');
    const stickyBuyNow = root.querySelector('[data-sticky-buy-now]');
    const availability = root.querySelector('[data-availability]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const shippingSummary = root.querySelector('[data-shipping-summary]');
    const shippingScript = document.querySelector('[data-product-shipping-script]');
    const shippingCache = new Map();
    let shippingRequestId = 0;
    let shippingHelperWaitActive = false;
    let shippingHelperTimeout;
    let quantityDebounce;
    const labels = {
      inStock: root.dataset.labelInStock || 'In stock',
      soldOut: root.dataset.labelSoldOut || 'Sold out',
      preorder: root.dataset.labelPreorder || 'Pre-order',
      badgeHot: root.dataset.labelBadgeHot || 'Hot',
      badgeNew: root.dataset.labelBadgeNew || 'New',
      addToCart: root.dataset.labelAddToCart || 'ADD TO CART',
      buyNow: root.dataset.labelBuyNow || 'BUY NOW',
      preorderNow: root.dataset.labelPreorderNow || 'PRE-ORDER NOW',
      adding: root.dataset.labelAdding || 'ADDING...',
      ready: root.dataset.labelReady || 'Ready for secure checkout with the selected option.',
      chooseAvailable: root.dataset.labelChooseAvailable || 'Choose another option available in the selected region.',
      shippingLoading: root.dataset.labelShippingLoading || 'Checking shipping for the selected option...',
      shippingUnavailable: root.dataset.labelShippingUnavailable || 'Select an available option to view shipping.',
      shippingError: root.dataset.labelShippingError || 'Shipping rates are confirmed at checkout.',
      shippingFree: root.dataset.labelShippingFree || 'Free shipping available for this item in the selected region.',
      shippingEstimated: root.dataset.labelShippingEstimated || 'Estimated shipping from %amount%.',
      shippingThreshold: root.dataset.labelShippingThreshold || 'Free shipping over %amount%.',
    };
    const productBadgeHot = root.dataset.productBadgeHot === 'true';
    const productBadgeNew = root.dataset.productBadgeNew === 'true';
    const productBadgePreorder = root.dataset.productBadgePreorder === 'true';
    const selectedOptions = Array.from(root.querySelectorAll('[data-option-index]')).map((field) => {
      const selected = field.querySelector('.is-selected');
      return selected?.getAttribute('data-option-value') || '';
    });
    const getShippingHelpers = () => window.FuncinatingProductShipping;
    const getSelectedMarketSummary = (variant) =>
      getShippingHelpers()?.readMarketSummary?.(variant?.marketShippingSummary, root.dataset.countryCode || '') || null;

    const findVariant = () =>
      variants.find((variant) => variant.options.every((value, index) => selectedOptions[index] === value));

    const replaceLabelTokens = (template, replacements = {}) =>
      Object.entries(replacements).reduce(
        (text, [key, value]) => text.replaceAll(`%${key}%`, String(value)),
        template
      );

    const applyShippingCopy = (state) => {
      if (!shippingSummary) return;

      if (!state?.option) {
        shippingSummary.textContent = labels.shippingError;
        return;
      }

      const shippingHelpers = getShippingHelpers();
      if (!shippingHelpers?.formatMoney) return;

      const thresholdAmount =
        state.freeShippingThreshold != null && Number(state.freeShippingThreshold) > 0
          ? shippingHelpers.formatMoney(Number(state.freeShippingThreshold), state.freeShippingThresholdCurrencyCode || state.option.currencyCode, {
              locale: document.documentElement.lang || undefined,
              countryCode: root.dataset.countryCode || undefined,
            })
          : '';

      if (thresholdAmount) {
        shippingSummary.textContent = replaceLabelTokens(labels.shippingThreshold, {
          amount: thresholdAmount,
        });
        return;
      }

      if (state.isFreeShipping) {
        shippingSummary.textContent = labels.shippingFree;
        return;
      }

      shippingSummary.textContent = labels.shippingError;
    };

    const applySyncedMarketSummary = (marketSummary) => {
      if (!shippingSummary || !marketSummary) return false;

      const syncedShippingState = getShippingHelpers()?.createShippingStateFromSummary?.(marketSummary);
      if (!syncedShippingState) return false;

      if (!syncedShippingState.available) {
        const selectedVariant = findVariant() || variants[0];
        if (selectedVariant?.available || selectedVariant?.sellingPlan?.id) return false;
        setShippingFallback(labels.shippingUnavailable);
        return true;
      }

      if (syncedShippingState.option) {
        applyShippingCopy(syncedShippingState);
        return true;
      }

      return false;
    };

    const setShippingFallback = (shippingText) => {
      if (shippingSummary) shippingSummary.textContent = shippingText;
    };

    const onShippingHelpersReady = () => {
      if (shippingHelperTimeout) {
        window.clearTimeout(shippingHelperTimeout);
        shippingHelperTimeout = undefined;
      }

      if (!shippingHelperWaitActive) return;
      shippingHelperWaitActive = false;
      updateShippingEstimate();
    };

    const updateShippingEstimate = async () => {
      const variant = findVariant() || variants[0];
      const marketSummary = getSelectedMarketSummary(variant);

      if (marketSummary && applySyncedMarketSummary(marketSummary)) {
        return;
      }

      if (!variant?.available && !variant?.sellingPlan?.id) {
        setShippingFallback(labels.shippingUnavailable);
        return;
      }

      const shippingHelpers = getShippingHelpers();

      if (!shippingHelpers?.fetchEstimatedShipping) {
        if (!shippingHelperWaitActive) {
          shippingHelperWaitActive = true;
          shippingScript?.addEventListener('load', onShippingHelpersReady, { once: true });
          shippingHelperTimeout = window.setTimeout(onShippingHelpersReady, 2400);
        }
        return;
      }

      if (shippingHelperTimeout) {
        window.clearTimeout(shippingHelperTimeout);
        shippingHelperTimeout = undefined;
      }
      shippingHelperWaitActive = false;

      if (!root.dataset.storefrontAccessToken) {
        setShippingFallback(labels.shippingError);
        return;
      }

      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const countryCode = root.dataset.countryCode || '';
      const cacheKey = `${variant.id}:${quantity}:${countryCode}`;
      const currentRequestId = ++shippingRequestId;

      if (shippingCache.has(cacheKey)) {
        applyShippingCopy(shippingCache.get(cacheKey));
        return;
      }

      try {
        const shippingState = await shippingHelpers.fetchEstimatedShipping({
          storeDomain: root.dataset.storeDomain,
          accessToken: root.dataset.storefrontAccessToken,
          apiVersion: root.dataset.storefrontApiVersion,
          countryCode,
          merchandiseId: String(variant.id),
          quantity,
        });

        if (currentRequestId !== shippingRequestId) return;
        shippingCache.set(cacheKey, shippingState);
        applyShippingCopy(shippingState);
      } catch {
        if (currentRequestId !== shippingRequestId) return;
        setShippingFallback(labels.shippingError);
      }
    };

    const updateOptionAvailability = () => {
      root.querySelectorAll('[data-option-index]').forEach((field, optionIndex) => {
        field.querySelectorAll('[data-option-value]').forEach((button) => {
          const nextOptions = [...selectedOptions];
          nextOptions[optionIndex] = button.getAttribute('data-option-value') || '';
          const exists = variants.some((variant) =>
            variant.options.every((value, index) => nextOptions[index] === value)
          );
          button.disabled = !exists;
        });
      });
    };

    const updateVariant = () => {
      const variant = findVariant() || variants[0];
      if (!variant) return;
      const isPreorder = Boolean(variant.sellingPlan?.id);
      const variantAvailable = variant.available || isPreorder;
      let badgeLabel = '';

      if (productBadgePreorder) {
        badgeLabel = labels.preorder;
      } else if (productBadgeHot) {
        badgeLabel = labels.badgeHot;
      } else if (productBadgeNew) {
        badgeLabel = labels.badgeNew;
      }

      variantInput.value = variant.id;
      sellingPlanInput.value = variant.sellingPlan?.id || '';
      sellingPlanInput.disabled = !isPreorder;
      preorderNotice.hidden = !isPreorder;
      price.textContent = variant.price;
      comparePrice.textContent = variant.compareAtPrice;
      comparePrice.hidden = !variant.hasCompareAtPrice;
      if (productBadge) {
        productBadge.textContent = badgeLabel.toUpperCase();
        productBadge.hidden = !badgeLabel;
        productBadge.classList.toggle('is-preorder', productBadgePreorder);
      }
      availability.hidden = isPreorder;
      availability.textContent = variantAvailable ? labels.inStock : labels.soldOut;
      availability.classList.toggle('is-unavailable', !variantAvailable);
      addToCart.disabled = !variantAvailable;
      addToCart.textContent = variantAvailable ? labels.addToCart : labels.soldOut;
      buyNow.disabled = !variantAvailable;
      buyNow.textContent = isPreorder ? labels.preorderNow : labels.buyNow;
      stickyPrice.textContent = variant.price;
      stickyOption.textContent = variant.options.join(' / ');
      stickyBuyNow.disabled = !variantAvailable;
      stickyBuyNow.textContent = isPreorder ? labels.preorderNow : labels.buyNow;
      updateOptionAvailability();
      updateShippingEstimate();
    };

    root.querySelectorAll('[data-option-index]').forEach((field, optionIndex) => {
      field.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          selectedOptions[optionIndex] = button.getAttribute('data-option-value') || '';
          field.querySelectorAll('[data-option-value]').forEach((optionButton) =>
            optionButton.classList.toggle('is-selected', optionButton === button)
          );
          const selectedLabel = field.querySelector('[data-selected-option-value]');
          if (selectedLabel) selectedLabel.textContent = selectedOptions[optionIndex];
          updateVariant();
        });
      });
    });

    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
      updateShippingEstimate();
    });

    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      quantityInput.value = String(Math.min(99, Number(quantityInput.value || 1) + 1));
      updateShippingEstimate();
    });

    quantityInput?.addEventListener('input', () => {
      clearTimeout(quantityDebounce);
      quantityDebounce = setTimeout(() => {
        updateShippingEstimate();
      }, 180);
    });

    quantityInput?.addEventListener('change', () => {
      updateShippingEstimate();
    });

    const submitProduct = async ({ checkout = false } = {}) => {
      const formData = new FormData(form);
      addToCart.disabled = true;
      buyNow.disabled = true;
      stickyBuyNow.disabled = true;
      addToCart.textContent = labels.adding;

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
          credentials: 'same-origin',
        });

        if (!response.ok) throw new Error('Add to cart failed');
        if (checkout) {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
          return;
        }
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch {
        updateVariant();
      }
    };

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      submitProduct();
    });

    buyNow?.addEventListener('click', () => submitProduct({ checkout: true }));
    stickyBuyNow?.addEventListener('click', () => submitProduct({ checkout: true }));

    if (originalButtons && stickyPurchase && 'IntersectionObserver' in window) {
      const purchaseObserver = new IntersectionObserver(([entry]) => {
        const shouldShow = !entry.isIntersecting;
        stickyPurchase.classList.toggle('is-visible', shouldShow);
        stickyPurchase.setAttribute('aria-hidden', String(!shouldShow));
        stickyBuyNow.tabIndex = shouldShow ? 0 : -1;
      }, { threshold: 0.2 });
      purchaseObserver.observe(originalButtons);
    }

    updateVariant();
  };

  const initFuncinatingGallery = (root) => {
    const track = root.querySelector('[data-gallery-track]');
    const dots = Array.from(root.querySelectorAll('[data-gallery-dot]'));
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const realCount = dots.length;
    let resetTimer;

    if (!track || realCount <= 1) return;

    const slideTo = (slideIndex, behavior = 'smooth') => {
      track.scrollTo({ left: track.clientWidth * slideIndex, behavior });
    };

    const setActive = (imageIndex) => {
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === imageIndex));
      thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === imageIndex));
    };

    const getSlideIndex = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    const getImageIndex = (slideIndex) => {
      if (slideIndex === 0) return realCount - 1;
      if (slideIndex === realCount + 1) return 0;
      return slideIndex - 1;
    };

    track.scrollTo({ left: track.clientWidth, behavior: 'auto' });

    // PR-2b(2026-09-04):非首图幻灯用 data-src 占位,滑到相邻(横向 1.2 个轨道宽)时再加载;
    // 首次触摸/按下即全部加载,避免快速连滑看到占位。IO 不可用时直接全部加载。
    const deferred = Array.from(track.querySelectorAll('img[data-gallery-deferred]'));
    const hydrate = (img) => {
      if (!img.dataset.src) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.src;
      delete img.dataset.srcset;
    };
    const hydrateAll = () => deferred.forEach(hydrate);
    if (deferred.length) {
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            hydrate(entry.target);
            io.unobserve(entry.target);
          });
        }, { root: track, rootMargin: '0px 120% 0px 120%' });
        deferred.forEach((img) => io.observe(img));
      } else {
        hydrateAll();
      }
      track.addEventListener('touchstart', hydrateAll, { passive: true, once: true });
      track.addEventListener('pointerdown', hydrateAll, { passive: true, once: true });
      root.querySelector('[data-gallery-next]')?.addEventListener('click', hydrateAll, { once: true });
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', hydrateAll, { once: true });
    }

    track.addEventListener('scroll', () => {
      const slideIndex = getSlideIndex();
      setActive(getImageIndex(slideIndex));
      clearTimeout(resetTimer);
      resetTimer = setTimeout(() => {
        const current = getSlideIndex();
        if (current === 0) slideTo(realCount, 'auto');
        if (current === realCount + 1) slideTo(1, 'auto');
      }, 120);
    });

    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => slideTo(getSlideIndex() - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => slideTo(getSlideIndex() + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => slideTo(index + 1)));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => slideTo(index + 1)));
  };

  document.querySelectorAll('[data-funcinating-product]').forEach((root) => {
    initFuncinatingProduct(root);
    initFuncinatingGallery(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
